<template>
  <div
    class="flight"
    :id="'uniqueid' + flightDetails.key.replace(/-/g, '')"
  >
    <div class="logo">
      <div
        class="logo-and-title"
        v-for="code in airlineCodes"
        :key="code.index"
      >
        <img class="logo-image" :src="getPathToLogo(code)" alt="airline logo" />
      </div>
    </div>
    <div class="trip-details">
      <template v-for="(leg, index) in flightDetails.odoList">
        <hr v-if="index !== 0" class="leg-divider" :key="`header-${index}`" />
        <div class="trip-leg" :key="`leg-${index}`">
          <span class="trip-leg__details" :key="`details-${index}`">
            {{ getLegDepartureAirportCode(leg) }}
            <b>{{ leg.departureTime }}</b>
            <b-icon icon="airplane" size="is-small"></b-icon>
            <b>{{ leg.arrivalTime }}</b>
            {{ getLegArrivalAirportCode(leg) }}
          </span>
          <span class="trip-leg__properties" :key="`properties-${index}`"
            >{{ leg.totalTime }},
            {{ leg.stops === 0 ? "nonstop" : `${leg.stops} stop(s)` }},
            {{ leg.segments[0].cabinClass.toLowerCase() }}</span
          >
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";

export default {
  name: "flight",
  props: {
    flightDetails: Object,
    direction: String,
  },
  data: function() {
    let scrollOptions = {
      easing: "ease-in",
      offset: -350,
      force: true,
      cancelable: false,
      x: false,
      y: true,
    };
    let scrollOptionsMobile = {
      easing: "ease-in",
      offset: -200,
      force: true,
      cancelable: false,
      x: false,
      y: true,
    };
    return {
      detailsOpen: false,
      mobile: window.innerWidth <= 781,
      scrollOptions: scrollOptions,
      scrollOptionsMobile: scrollOptionsMobile,
    };
  },
  computed: {
    ...mapState(["selectedFlights", "flags", "searchResults"]),
    airlineCodes() {
      let usedAirlineCodes = [];
      let airlineCodes = [];
      for (let leg of this.flightDetails.odoList) {
        for (let segment of leg.segments) {
          if (!usedAirlineCodes.includes(segment.airlineCode)) {
            usedAirlineCodes.push(segment.airlineCode);
            airlineCodes.push(segment.airlineCode);
          }
        }
      }
      return airlineCodes;
    },
    departureTimeZone() {
      return this.$store.state.departureTimeZone;
    },
    arrivalTimeZone() {
      return this.$store.state.arrivalTimeZone;
    },
  },
  methods: {
    niceDate(date) {
      return moment(date).format("MMMM Do, HH:mm a");
    },
    determineLocationFromCode(code) {
      if (this.searchResults) {
        return this.searchResults.airportInfos.find((e) => {
          return e.iataCode == code;
        });
      }
      return undefined;
    },
    getPathToLogo(marketingCode) {
      try {
        return require(`@/assets/images/logos/${marketingCode}.png`);
      } catch (error) {
        return require(`@/assets/images/logos/00.png`);
      }
    },
    getLegDepartureAirportCode(leg) {
      return leg.segments[0].origCode;
    },
    getLegArrivalAirportCode(leg) {
      return leg.segments[leg.segments.length - 1].destCode;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/settings.scss";

.flight {
  background: $light;
  cursor: pointer;
  padding: 0.75em 1em;
  padding-left: 0.75em;
  box-shadow: 0 1px 3px 0 rgba(32, 33, 36, 0.28);
  border-radius: 0.375rem;
  border-color: $primary-dark;
  border-width: 0.2px;
  display: grid;
  min-height: fit-content;
  grid-template-columns: 50px 1fr 1fr;
  grid-template-rows: auto;
  grid-auto-rows: auto;
  grid-row-gap: 0.75em;
  grid-column-gap: 0.5em;
  grid-template-areas:
    "logo trip-details trip-details"
    "details details details";
}

.more-details {
  grid-area: details;
}

.details-toggle {
  font-size: 0.8em;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  font-weight: bold;
  text-transform: uppercase;
}

.details-block {
  padding: 0.75em;
  padding-top: 0;
  display: flex;
  flex-wrap: wrap;
}

.nowrap {
  flex-wrap: wrap !important;
}

.overall {
  margin-left: 0.75em;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}

.overall-item {
  white-space: nowrap;
}

.segment {
  display: flex;
}

.leg {
  display: flex;
  flex-direction: column;
}

.leg-heading {
  margin: 0.75em;
}

.layover-warning {
  font-size: 0.8em;
  text-align: center;
  margin: 0.75em;
  color: $primary-dark;
  padding: 0.75em;
  border-radius: 4px;
  background-color: lighten($warning, 30%);
}

.locations {
  display: flex;
  flex-direction: column;
  margin-left: 0.75em;
}

.location {
  font-size: 0.8em;
}

.location:not(:first-child) {
  margin-top: 1.5em;
}

.small-margin-top {
  margin-top: 0.2em;
}

.route {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.select-wrapper {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.route-connect {
  width: 2px;
  height: 100%;
  background-color: $primary-color;
}

.toggle-icon {
  height: 0;
  margin-top: 0.3em;
}

.details-bar {
  background-color: $grey;
  margin: 0 0 0 0.75em;
  width: 100%;
  width: -webkit-fill-available;
}

.leg-details {
  height: 80px;
}

.extra-padding {
  padding: 1.3em 1em !important;
}

.selected {
  box-shadow: 0 0 8px $primary-color;
  border: 2px solid $secondary-color;
}

div {
  font-size: 10px;
}

.book-button {
  margin-left: auto;
}

.logo {
  grid-area: logo;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  * + * {
    margin-top: 8px;
  }
}

.logo-and-title {
  display: flex;
  flex-direction: column;
}

.logo-image {
  max-width: 50px;
  max-height: 40px;
}

.trip-details {
  grid-area: trip-details;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-around;
}

.leg-divider {
  width: 60%;
  margin: 0.3rem auto;
  height: 2px;
  background: $grey;
}

.trip-leg {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
}

.trip-leg__details {
  b {
    font-size: 1.2em;
    color: black;
  }
}

.trip-leg__properties {
  font-size: 0.8em;
  color: darken($grey, 40%);
}

.push-right {
  margin-left: auto;
}

.price {
  grid-area: price;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.booking-button {
  margin-top: 0.5em;
}

.flight {
      width: 100%;
    margin-bottom: 0.75em;
}

@media (min-width: 361px) {
  div {
    font-size: 14px;
  }
}

@media (min-width: 781px) {
  .flight {
    min-height: fit-content;
    width: 100%;
    grid-template-columns: 80px 1fr 1fr;
    grid-template-areas:
      "logo trip-details trip-details"
      "details details details";
  }

  .overall {
    margin-top: 0.75em;
    margin-left: 0;
    flex-direction: row;
    justify-content: flex-start;
    flex-wrap: wrap;
  }

  .leg {
    margin-left: 0.75em;
  }

  .details-block {
    flex-wrap: nowrap;
  }

  .logo-image {
    max-width: 80px;
    max-height: 40px;
  }
  .trip-details {
    justify-content: space-evenly;
  }
  .leg-divider {
    width: 4px;
    margin: 0;
    height: 4px;
    border-radius: 10px;
    background: black;
  }
}

@media (max-width: 780px) {
  .button {
    font-size: 0.8em !important;
  }
}
</style>
